<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/service">Serviços</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Novo serviço</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-body">
                        <form @submit="save">
                            <div class="row mt-3">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Descrição*</label>
                                    <input type="text" class="form-control" placeholder="Ex: Limpeza"
                                        v-model="service.name">
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Valor</label>
                                   <input type="text" class="form-control" v-model.lazy="service.amount" v-money="money">

                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                            class="fa fa-save"></i> Cadastrar</button>
                                    <router-link to="/service" class="btn btn-danger ml-3"><i class="fa fa-times"></i>
                                        Cancelar</router-link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { VMoney } from 'v-money'

export default {
    directives: {money: VMoney},
    components: { Loading },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            service: {
                name: ''
            },
            enable_error_list: false,
            errors: [],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            }
        }
    },

    computed: {
        isDisabled: function () {
            return this.service.name != '';
        }
    },
    mounted() {
        this.isLoading = false;
    },
    methods: {
        onCancel() { },

        save(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
             api.post('/service', this.service)
             .then(() => {
                 this.isLoading = false;
                 this.$notify({
                     title: "Sucesso",
                     text: "Serviço cadastrado com sucesso!",
                     type: 'success'
                 });
                 this.service = {};
             }).catch(error => {
                 this.isLoading = false;
                 if (error.status == 422) {
                     let response_errors = error.response.data.errors;
                     this.errors = response_errors;
                     this.enable_error_list = true;
                 }
                 handleRequestErrors(error.status, error);
             })

        }
    }
}
</script>

<style lang="scss" scoped></style>